/**
 * Funkce vrátí array s počty pokojů pro použití v React Select
 * @param {number} max Max. počet pokojů, který chceme vygenerovat
 * @param {string} roomType
 * @returns {Array}
 */
export function getNumberOfRoomsOptions(max, roomType) {
	let options = [];

	if (max < 1) max = 1;

	for (let value = 1; value <= max; value++) {
		options.push({
			value,
			label: [['utils.getNumberOfRoomsOptions.room' + (window.location.href.includes('hotelId=wlm910') /* chalupavapenka */ && roomType !== null ? '|' + roomType : ''), { count: value }]]
		});
	}

	return options;
}

/**
 * Funkce nalezne podle klíče (value) textový popisek (label) v seznamu hodnot pro select (options).
 * @param {Array} options
 * @param {string} value
 * @returns {(string|null)}
 */
export function getLabelForSelectedValue(options, value) {
	for (let option of options) {
		if (option.value === value) {
			return option.label;
		}
	}
	return null;
}

export function formatPrice(price, currency) {
	let formattedPrice = '';
	if (currency.position === 'before') {
		formattedPrice += currency.symbol;
	}
	formattedPrice += price.toLocaleString(currency.d_sep === ',' ? 'cs' : 'en-US', {
		minimumFractionDigits: currency.round,
		maximumFractionDigits: currency.round,
	});
	if (currency.position === 'after') {
		formattedPrice += ' ' + currency.symbol;
	}
	return formattedPrice;
}

/**
 * Funkce převede JSON objekt na URL encoded form data, která se dají zaslat
 * jako application/x-www-form-urlencoded.
 * @param element
 * @param key
 * @param list
 * @returns {string}
 */
export function jsonToUrlEncoded(element, key, list){
	list = list || [];

	if (typeof element === 'object') {
		for (let idx in element) {
			if (!element.hasOwnProperty(idx)) continue;
			jsonToUrlEncoded(element[idx], key ? key + '[' + idx + ']' : idx, list);
		}

	} else {
		list.push(key + '=' + encodeURIComponent(element));
	}

	return list.join('&');
}

/**
 * Odeslat zprávu parentovi, pokud je aplikace umístěna v iframu
 * @param type
 * @param value
 */
export function postMessageToParent(type, value) {
	window.parent.postMessage({ type, value }, '*');
}

/**
 * Vrací, zda je aplikace zobrazena v iframu.
 * @returns {boolean}
 */
export function inIframe() {
	return window.self !== window.top;
}


// WEBPACK FOOTER //
// ./src/utils.js